import { BaseModel, enumField, ModelInstance, ToBackHook, ToFrontHook } from './util';

export enum GameBasketballPosition {
  point_guard = 1,
  shooting_guard,
  small_forward,
  power_forward,
  center
}

export enum WorkHand {
  left = 1,
  right
}

@ModelInstance({
  mappingFields: {
    id: 'id',
    user_id: 'userId',
    position: 'position',
    work_hand: 'workHand'
  },
  relation: {
    position: enumField(GameBasketballPosition),
    workHand: enumField(WorkHand)
  }
})
export class BasketballProfile extends BaseModel {
  id: number;
  userId: number;
  position: GameBasketballPosition;
  workHand: WorkHand;

  @ToFrontHook
  static toFront(value: any): any {
  }

  @ToBackHook
  static toBack(value: any): any {
  }
}
